import {Injectable} from '@angular/core';
import {ConnectionService} from 'ng-connection-service';
import {ToasterService} from 'angular2-toaster';

@Injectable({
    providedIn: 'root'
})
export class InternetService {

    public isConnected = true;

    constructor(
        public connectionService: ConnectionService,
        public toasterService: ToasterService
    ) {
        this.internetConnection();
    }

    internetConnection() {
        this.connectionService.monitor().subscribe(isConnected => {
            this.isConnected = isConnected;
            if (!this.isConnected) {
                this.toasterService.pop('error', '', 'No internet connection');
            }
        });
    }
}
